import { REGISTER_WEBORDER } from "../actions/actionTypes";
import { initWebOrderState } from "../State";

const webOrderReducer = (state = initWebOrderState, action) => {
  if (action.type === REGISTER_WEBORDER) {
    return {
      ...state,
      userId: action.payload.userId,
      storeId: action.payload.storeId,
      storeName: action.payload.storeName,
      kiosk: action.payload.kiosk,
    };
  }
  return state;
};

export default webOrderReducer;
